import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const DrivePublicPage = lazy(() => import('src/pages/public-drive'));

// eslint-disable-next-line import/no-unresolved
const PublicWebsitePage = lazy(() => import('src/pages/public-website/PublicWebsitePage'));
const PublicSurveyPage = lazy(() => import('src/pages/survey/PublicSurveyPage'));

// Public Careers Portal
const CareersPage = lazy(() => import('src/pages/public-careers/CareersPage'));
const CareerApplicationPage = lazy(() => import('src/pages/public-careers/CareerApplicationPage'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      // { path: 'coming-soon', element: <ComingSoonPage /> },
      // { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
  {
    path: 'public/drive/:token',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <DrivePublicPage />
      </Suspense>
    ),
  },
  {
    path: 'survey/:orgId/:formId',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicSurveyPage />
      </Suspense>
    ),
  },
  {
    path: 'site/:slug',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicWebsitePage />
      </Suspense>
    ),
  },
  {
    path: 'site/:slug/:pageSlug',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicWebsitePage />
      </Suspense>
    ),
  },
  // ── Public Careers Portal ─────────────────────────────────────────────────
  {
    path: 'careers/:slug',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <CareersPage />
      </Suspense>
    ),
  },
  {
    path: 'careers/:slug/apply/:jobId',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <CareerApplicationPage />
      </Suspense>
    ),
  },
];
